import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Alert, Button, Spinner, Table, Modal,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from './Form';
import { Details } from './Details';

import { PageStatus } from 'enums';
import {Show} from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import {PartnersAPI} from "../../API";
import { Confirmation } from 'Shared/Confirmation';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";
import Swal from 'sweetalert2';


function appendParamsToUrl(baseUrl, partnerId) {
  if (baseUrl && partnerId) {
    try {
      const url = new URL(baseUrl);
      url.searchParams.append('partnerid', partnerId);
      return url.toString();
    } catch (error) {
      console.error('Invalid URL:', error.message);
      return baseUrl;
    }
  }
  console.error('Missing baseUrl or partnerId');
  return baseUrl;
}


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};


const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
  ADDPARTNERPARAMS: 'ADDPARTNERPARAMS',
};

type State = {
  status: PageStatus,
  error: string | null,
  formType: string,
  partners: any[],
  id?: string | null,
};

class PartnersListComponent extends Component<any, any> {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      formType: MODAL_TYPES.NONE,
      partners: [],
      id: null,
      name: "",
      type: "",
    };
    this.fetchList = this.fetchList.bind(this);
  }

  componentDidMount() {
    this.fetchList()
  }

  fetchList(): Promise<void> {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => PartnersAPI.getPartners(10000))
      .then((countries) => {
        this.setState({ partners: countries, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  isShowDetailModal(): boolean {
    return this.state.formType === MODAL_TYPES.DETAILS
        || this.state.formType === MODAL_TYPES.DELETE;
  }

  onShowModalFunc(): void {
    this.setState({formType: MODAL_TYPES.ADDPARTNERPARAMS});
  }
  
  onCloseModalFunc(): void {
    this.setState({formType: MODAL_TYPES.NONE});
  }

  deletePartner(id): Promise<void> {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => PartnersAPI.deletePartner(id))
      .then(() => {
        Swal.fire({ icon: 'success', title: 'Deleted', text: 'Partner deleted successfully.' });
        this.setState({ status: PageStatus.Loaded }, () => { this.fetchList(); });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  addPartnerParamFunc(): Promise<void> {
    if(this.state.name) {
      return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => PartnersAPI.createPartnerParameters({name: this.state.name, type: this.state.type}))
      .then(() => {this.setState({ status: PageStatus.Loaded, name: "", type: "" });})
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
    }else{
      alert("Please enter name.");
      return Promise.resolve()
    }
  }

  render() {
    const lang = this.context || 'en';
    const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
    return (
        <>
        <GridContainer>
            <div className='w-100 mb-3'>
              <CardHeader color="primary">
                <div className="d-flex align-items-center justify-content-between">
                <h4>{t("Partners")}</h4>
                <div>
                  {this.props.role !== 'sales' && (
                    <>
                      <Button
                          onClick={() => { this.onShowModalFunc() }}
                          variant="info"
                          size="sm"
                          className="mx-1 d-none"
                      >
                        <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                        {t("Add partner passback variable")}
                      </Button>
                      <Button
                          onClick={() => {
                                                    return this.setState({
                                                        formType: MODAL_TYPES.CREATE,
                                                    });
                                                }}
                          variant="primary"
                          size="sm"
                          className="mx-1"
                      >
                        <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                        {t("Create")}
                      </Button>
                    </>
                  )}
                </div>
                </div>
              </CardHeader>
            </div>
        </GridContainer>
      <div className="jumbotron bg-white p-3 border shadow-sm">
        <Alert variant="danger" show={this.state.status === PageStatus.Error}>
          {this.state.error}
        </Alert>

        <Show when={this.state.status === PageStatus.Loading}>
          <div className="d-flex justify-content-center w-100 p-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Show>

        <Show when={this.state.status === PageStatus.Loaded}>
          <Show when={this.state.formType === MODAL_TYPES.CREATE}>
            <Form
              show={this.state.formType === MODAL_TYPES.CREATE}

              onClose={() => this.setState({
                formType: MODAL_TYPES.NONE,
              })}
              onSubmit={(id) => {
                this.fetchList();
                this.setState({
                  formType: MODAL_TYPES.DETAILS, id: id,
                });
              }}
            />
          </Show>

          <Show when={!this.state.partners.length}>
            <Alert variant="info" show={!this.state.partners.length}>
              {t("No data is available")}
            </Alert>
          </Show>

          <Show when={!!this.state.partners.length}>
            <Show when={this.isShowDetailModal()}>
              <Details id={this.state.id} role={this.props.role}

                onClose={() => this.setState({
                  formType: MODAL_TYPES.NONE,
                  id: null,
                })}
                onUpdate={() => {
                  this.setState({
                    formType: MODAL_TYPES.UPDATE,
                  });
                }}
                onDelete={(id) => {
                  this.setState({
                    formType: MODAL_TYPES.DELETE,
                    id: id,
                  });
                }}
              />
            </Show>

            <Show when={this.state.formType === MODAL_TYPES.UPDATE}>
              <Form
                show={this.state.formType === MODAL_TYPES.UPDATE}
                id={this.state.id}

                onClose={() => this.setState({
                  formType: MODAL_TYPES.NONE,
                  id: null,
                })}
                onSubmit={(id) => {
                  this.fetchList();
                  this.setState({
                    formType: MODAL_TYPES.DETAILS, id: id,
                  });
                }}
              />
            </Show>

          <Table responsive size="sm" bordered>
            <thead>
              <tr>
                <th>{t("S.No")}</th>
                <th>{t("Name")}</th>
                <th>{t("Description")}</th>
                <th>{t("Completed URL")}</th>
                <th>{t("Quota Full URL")}</th>
                <th>{t("CreatedAt")}</th>
                <th>{t("UpdatedAt")}</th>
                <th>{t("Actions")}</th>
              </tr>
            </thead>

            <tbody>
              {
                this.state.partners.map((data, index) => (
                  <tr key={data.id}>
                    <td>{index + 1}</td>
                    <td>
                      <button
                        className="text-primary bg-transparent text-start d-block"
                        onKeyPress={() => null}
                        onClick={() => {
                          this.setState({
                            formType: MODAL_TYPES.DETAILS,
                            id: data.id,
                          });
                        }}
                        >
                        <div
                          style={{textAlign:"left", display:"block", whiteSpace:"normal"}}
                          dangerouslySetInnerHTML={{
                            __html: data.name || 'Title',
                          }}
                        ></div>
                      </button>
                    </td>
                    <td>{data.description}</td>
                    <td>{appendParamsToUrl(data.successUrl, data?.id)}</td>
                    <td>{appendParamsToUrl(data.successUrl, data?.id)}</td>
                    <td>{moment(data.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                    <td>{moment(data.updatedAt).format('MM/DD/YYYY HH:mm A')}</td>
                    <td>
                      <Confirmation onAction={() => this.deletePartner(data.id)} body={t("Are you sure you want to delete this partner? This action cannot be undone.")}>
                        <button className='btn btn-danger btn-sm'>{t("Delete")}</button>
                      </Confirmation>
                    </td>
                  </tr>
                ))
              }
            </tbody>

          </Table>
        </Show>
        </Show>
      </div>
        <Modal
          centered
          size="lg"
          backdrop="static"
          onHide={() => this.onCloseModalFunc()}
          show={this.state.formType === "ADDPARTNERPARAMS"}
          style={{ zIndex: 1201, background: "rgba(0, 0, 0, 0.3)" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("Add Partner Passback Variable")}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
            <Show when={this.state.status === PageStatus.Loading}>
              <div className="d-flex justify-content-center w-100 p-5">
                <Spinner animation="border" variant="primary" />
              </div>
            </Show>
            <Alert variant="danger" show={this.state.status === PageStatus.Error}>  {this.state.error}  </Alert>
            <Show when={this.state.status != PageStatus.Loading}>
              <div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="name">{t("Partner Passback Variable")}*</label>
                    <input
                      className="form-control mx-1"
                      name="name"
                      onChange={(e) => {this.setState({name: e.target.value.trim()})}}
                      value = { this.state.name }
                      type='text'
                      placeholder={t("Enter here")}
                      required
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                  <button onClick={() => this.addPartnerParamFunc()} className="btn btn-primary">
                    {t("Add")}
                  </button>
                </div>
              </div>
            </Show>
          </Modal.Body>
        </Modal>
        </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  role: state.adminUser?.adminUser?.role,
});

export const PartnersList = connect(mapStateToProps)(PartnersListComponent);
